import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";


import { useNavigate } from "react-router-dom";
import { Button, Snackbar, Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import TextArea from "../../../atoms/Textarea";
import DynamicCheckbox from "../../../molecules/DynamicCheckbox";
import Table from "@mui/material/Table";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../../atoms/Input";
import removeImg from "../../../../imgs/remove.png";
import { useParams, useLocation } from "react-router-dom";
import { ToWords } from "to-words";
import WoodenLiftPageDownload from "./download";
import PrintComponent from "../../PrintComponent";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import InventoryIcon from "@mui/icons-material/Inventory";
import CommentIcon from "@mui/icons-material/Comment";
import GavelIcon from "@mui/icons-material/Gavel";
import ChecklistIcon from "@mui/icons-material/Checklist";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

const WoodenLiftPageClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [surveyData, setSurveyData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  var totalAmount = 0;

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);

  const words = new ToWords();

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage(
            "Wooden Lift Van Quality Check Report has been updated successfully!"
          );

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setIsValid(false);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        setIsLoading(false);
        setMediaKeysToSend([]);
      });
  };

  useEffect(() => {
    getContent();
  }, []);


  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");


  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");

  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");


  //
  const uploadFile = async (file) => {

    setIsLoading(true);


    if (whichSign == "manager") setUploadText1("Uploading...");
    if (whichSign == "carpenter") setUploadText2("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        if (whichSign == "manager")
          values.managerWarehouseSign = res?.data?.data?.key;
        if (whichSign == "carpenter") values.carpenterSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");

        setIsLoading(false);
      });

  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <>
      {isValid ? (
        <>
            <PremiumPublicLayout
            title="Wooden Lift Van Quality Check Report"
            hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                {!isEdit && (
                    <Button
                    variant="contained"
                    onClick={() => {
                        setIsEdit(true);
                    }}
                    disabled={isLoading}
                    sx={{ 
                        textTransform: "none", 
                        borderRadius: "var(--radius-md)", 
                        padding: "10px 24px",
                        fontWeight: 700,
                        backgroundColor: "var(--primary-color)",
                        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                        '&:hover': { backgroundColor: 'var(--primary-hover)' }
                    }}
                    startIcon={<NoteAltIcon />}
                    >
                    Edit
                    </Button>
                )}
                {isEdit && (
                    <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                        getContent();
                        setIsEdit(false);
                    }}
                    disabled={isLoading}
                    sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                    >
                    Cancel
                    </Button>
                )}

                {isEdit && (
                    <Button
                    variant="contained"
                    onClick={() => {
                        updateContent();
                    }}
                    disabled={isLoading}
                    sx={{ 
                        textTransform: "none", 
                        borderRadius: "var(--radius-md)", 
                        padding: "10px 32px",
                        fontWeight: 700,
                        backgroundColor: "var(--primary-color)",
                        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                        '&:hover': { backgroundColor: 'var(--primary-hover)' }
                    }}
                    >
                    Save
                    </Button>
                )}

                {!isEdit && (
                    <Button
                    variant="contained"
                    onClick={() => {
                        if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                        var tempTitle = document.title;
                        document.title = `Wooden-Lift-Van-Quality-Check-Report-${formContent?.customerName
                        }-${moment(new Date()).format("DD.MM.YYYY")}`;

                        window.print();
                        document.title = tempTitle;
                        setIsLoading(false);
                    }}
                    disabled={isLoading}
                    sx={{ 
                        textTransform: "none", 
                        borderRadius: "var(--radius-md)", 
                        padding: "10px 24px",
                        fontWeight: 700,
                        backgroundColor: "var(--text-main)",
                        boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                        '&:hover': { backgroundColor: '#000' }
                    }}
                    startIcon={<DescriptionIcon />}
                    >
                    Save as PDF
                    </Button>
                )}
                </div>
            }
            >
            <SectionHeader title="Customer Details" icon={<DescriptionIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={4}>
                     <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="Customer Name"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.customerName}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.customerName = e.target.value;
                                setFormContent(values);
                            }}
                            disabled
                        />
                     </Grid>
                     <Grid item xs={12} md={6}>
                        <ContactDetailField
                            label="File Ref"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.fileRef}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.fileRef = e.target.value;
                                setFormContent(values);
                            }}
                            disabled
                        />
                     </Grid>
                 </Grid>
            </PremiumCard>

            <SectionHeader title="Wooden Lift Vans Inventory" icon={<InventoryIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
                <div className="overflow-x-auto">
                    <Table
                        responsive
                        style={{ overflowX: "auto" }}
                    >
                        {/* Table Header */}
                        <thead className="bg-white">
                        <tr>
                            <th className="border p-3 text-start min-w-150">
                            No. of Wooden lift vans
                            </th>
                            <th className="border p-3 text-start min-w-400">
                            Lift van or Box Sizes IN/OUT
                            </th>
                            <th className="border p-3 text-start">Tare weight</th>
                            <th className="border p-3 text-start min-w-100">
                            Manufacturer Date
                            </th>
                        </tr>
                        </thead>
                        <tbody className="bg-white">
                        {formContent?.dataRows?.length > 0 ? (
                            <>
                            {formContent?.dataRows?.map((row, index) => {
                                return (
                                <tr key={index}>
                                    <td className="border p-3 text-start">
                                    {index + 1}
                                    </td>
                                    <td className="border p-3 text-start">
                                    {isEdit ? (
                                        <Input
                                        id="condition"
                                        label="Lift van or Box Sizes.."
                                        type="text"
                                        style="full-border-field"
                                        value={row?.liftVanBoxSizes}
                                        onChange={(e) => {
                                            const values = { ...formContent };
                                            const valuesRows = [
                                            ...formContent?.dataRows,
                                            ];
                                            valuesRows[index].liftVanBoxSizes =
                                            e.target.value;
                                            values.dataRows = valuesRows;
                                            setFormContent(values);
                                        }}
                                        inline={{ width: "-webkit-fill-available" }}
                                        disabled={true}
                                        />
                                    ) : row.liftVanBoxSizes ? (
                                        row.liftVanBoxSizes
                                    ) : (
                                        "-"
                                    )}
                                    </td>
                                    <td className="border p-3 text-start min-w-100">
                                    {isEdit ? (
                                        <>
                                        <Input
                                            id="condition"
                                            label="Tare weight..."
                                            type="text"
                                            style="full-border-field"
                                            value={row?.tareWt}
                                            onChange={(e) => {
                                            const values = { ...formContent };
                                            const valuesRows = [
                                                ...formContent?.dataRows,
                                            ];
                                            valuesRows[index].tareWt = e.target.value;
                                            values.dataRows = valuesRows;
                                            setFormContent(values);
                                            }}
                                            inline={{ width: "-webkit-fill-available" }}
                                            disabled={true}
                                        />
                                        </>
                                    ) : row.tareWt ? (
                                        `${row.tareWt}`
                                    ) : (
                                        "-"
                                    )}
                                    </td>
                                    <td className="border p-3 text-start min-w-100">
                                    {isEdit ? (
                                        <>
                                        <Input
                                            id="condition"
                                            label="Date..."
                                            type="date"
                                            style="full-border-field"
                                            value={row?.date}
                                            onChange={(e) => {
                                            const values = { ...formContent };
                                            const valuesRows = [
                                                ...formContent?.dataRows,
                                            ];
                                            valuesRows[index].date = e.target.value;
                                            values.dataRows = valuesRows;
                                            setFormContent(values);
                                            }}
                                            inline={{ width: "-webkit-fill-available" }}
                                            disabled={true}
                                        />
                                        </>
                                    ) : row.date ? (
                                        formatDate(row.date)
                                    ) : (
                                        "-"
                                    )}
                                    </td>
                                </tr>
                                );
                            })}
                            </>
                        ) : (
                            <tr>
                            <td className="text-center" colSpan={isEdit ? 5 : 4}>
                                {isLoading ? (
                                <Box
                                    sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "10px 0px",
                                    }}
                                >
                                    <CircularProgress
                                    style={{
                                        color: "#00aff0",
                                        height: "25px",
                                        width: "25px",
                                    }}
                                    />
                                </Box>
                                ) : (
                                <div className="d-flex justify-content-center">
                                    <p className="my-3">No Records to Show</p>
                                </div>
                                )}
                            </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                </div>
            </PremiumCard>

            <SectionHeader title="Quality Checklist" icon={<ChecklistIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="1. The correct size of lift van was measured."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.correctSize}
                    value2={formContent?.correctSize}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.correctSize = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.correctSize = false;
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="">
                  <Typography
                    variant="body1"
                    className="text-start"
                    gutterBottom
                  >
                    <DynamicCheckbox
                      label="2. The crates build with new ply wood sheets."
                      checkId1="check1"
                      checkLabel1="Yes"
                      checkId2="check2"
                      checkLabel2="No"
                      value1={formContent?.plyWood}
                      value2={formContent?.plyWood}
                      onChange1={(e) => {
                        let values = { ...formContent };
                        values.plyWood = true;
                        setFormContent(values);
                      }}
                      onChange2={(e) => {
                        let values = { ...formContent };
                        values.plyWood = false;
                        setFormContent(values);
                      }}
                      disabled={true}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="3. The crates build with new wood bars."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.woodBars}
                    value2={formContent?.woodBars}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.woodBars = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.woodBars = false;
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="">
                  <Typography
                    variant="body1"
                    className="text-start"
                    gutterBottom
                  >
                    <DynamicCheckbox
                      label="4. All the parts and joints are well together."
                      checkId1="check1"
                      checkLabel1="Yes"
                      checkId2="check2"
                      checkLabel2="No"
                      value1={formContent?.partsWellTogether}
                      value2={formContent?.partsWellTogether}
                      onChange1={(e) => {
                        let values = { ...formContent };
                        values.partsWellTogether = true;
                        setFormContent(values);
                      }}
                      onChange2={(e) => {
                        let values = { ...formContent };
                        values.partsWellTogether = false;
                        setFormContent(values);
                      }}
                      disabled={true}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="5. Is there any holes/cracks found in the crate?"
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.holesCrakes}
                    value2={formContent?.holesCrakes}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.holesCrakes = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.holesCrakes = false;
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="">
                  <Typography
                    variant="body1"
                    className="text-start"
                    gutterBottom
                  >
                    <DynamicCheckbox
                      label="6. If yes, has the holes/cracks filled up with silicon?"
                      checkId1="check1"
                      checkLabel1="Yes"
                      checkId2="check2"
                      checkLabel2="No"
                      value1={formContent?.holesFilledWithSilicon}
                      value2={formContent?.holesFilledWithSilicon}
                      onChange1={(e) => {
                        let values = { ...formContent };
                        values.holesFilledWithSilicon = true;
                        setFormContent(values);
                      }}
                      onChange2={(e) => {
                        let values = { ...formContent };
                        values.holesFilledWithSilicon = false;
                        setFormContent(values);
                      }}
                      disabled={true}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="7. The crates fully waterproofed from inside with plastic sheets."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.cratesWaterproof}
                    value2={formContent?.cratesWaterproof}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.cratesWaterproof = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.cratesWaterproof = false;
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="">
                  <Typography
                    variant="body1"
                    className="text-start"
                    gutterBottom
                  >
                    <DynamicCheckbox
                      label="8. The crates roof top has intact with tin sheet."
                      checkId1="check1"
                      checkLabel1="Yes"
                      checkId2="check2"
                      checkLabel2="No"
                      value1={formContent?.cratesRoof}
                      value2={formContent?.cratesRoof}
                      onChange1={(e) => {
                        let values = { ...formContent };
                        values.cratesRoof = true;
                        setFormContent(values);
                      }}
                      onChange2={(e) => {
                        let values = { ...formContent };
                        values.cratesRoof = false;
                        setFormContent(values);
                      }}
                      disabled={true}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="9 .The signs and shipper details are clearly mentioned on crates"
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.clearlyMentioned}
                    value2={formContent?.clearlyMentioned}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.clearlyMentioned = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.clearlyMentioned = false;
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="">
                  <Typography
                    variant="body1"
                    className="text-start"
                    gutterBottom
                  >
                    <DynamicCheckbox
                      label="10. The crates tie-up with steel bindings all around."
                      checkId1="check1"
                      checkLabel1="Yes"
                      checkId2="check2"
                      checkLabel2="No"
                      value1={formContent?.tiedUpCrates}
                      value2={formContent?.tiedUpCrates}
                      onChange1={(e) => {
                        let values = { ...formContent };
                        values.tiedUpCrates = true;
                        setFormContent(values);
                      }}
                      onChange2={(e) => {
                        let values = { ...formContent };
                        values.tiedUpCrates = false;
                        setFormContent(values);
                      }}
                      disabled={true}
                    />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="body1" className="text-start" gutterBottom>
                  <DynamicCheckbox
                    label="11. The tare weight of the lift van noted."
                    checkId1="check1"
                    checkLabel1="Yes"
                    checkId2="check2"
                    checkLabel2="No"
                    value1={formContent?.tareWeightNoted}
                    value2={formContent?.tareWeightNoted}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.tareWeightNoted = true;
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.tareWeightNoted = false;
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </Grid>
              </Grid>
            </PremiumCard>

            {/* Remarks */}
           <SectionHeader title="Remarks" icon={<CommentIcon />} />
           <PremiumCard sx={{ marginBottom: "32px" }}>
            <div className="mb-4">
              <label htmlFor="carpenterRemarks" className={`fw-bold mb-2`}>
                Carpenter Remarks:
              </label>
              {!isEdit ? (
                <Typography variant="body1">
                  {formContent?.carpenterRemarks ? formContent?.carpenterRemarks : "-"}
                </Typography>
              ) : (
                <TextArea
                  rows="3"
                  label="Carpenter remarks..."
                  id="carpenterRemarks"
                  value={formContent?.carpenterRemarks}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.carpenterRemarks = e.target.value;
                    setFormContent(values);
                  }}
                />
              )}
            </div>

            <div className="mb-2">
              <label htmlFor="managerWarehouse" className={`fw-bold mb-2`}>
                Manager Warehouse Remarks:
              </label>
              {!isEdit ? (
                <Typography variant="body1">
                  {formContent?.managerRemarks ? formContent?.managerRemarks : "-"}
                </Typography>
              ) : (
                <TextArea
                  rows="3"
                  label="Manager warehouse remarks:..."
                  id="managerWarehouse"
                  value={formContent?.managerRemarks}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.managerRemarks = e.target.value;
                    setFormContent(values);
                  }}
                />
              )}
            </div>
           </PremiumCard>

           {/* Authorization */}
           <SectionHeader title="Authorization" icon={<GavelIcon />} />
           <PremiumCard sx={{ marginBottom: "32px" }}>
             <Grid container spacing={2} sx={{ mt: 4 }}>
               <Grid item xs={12} sm={6}>
                 <div
                   style={{ height: "90px" }}
                   className="d-flex justify-content-center align-items-end"
                 >
                   {formContent?.managerWarehouseSign?.trim()?.length == 0 ? (
                    <>
                       {isEdit && (
                         <div className="d-flex justify-content-center align-items-end">
                           <label
                             htmlFor="uploadSign"
                             className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                           >
                             {uploadText1}
                           </label>
                           <input
                             type="button"
                             hidden
                             id="uploadSign"
                             name="uploadSign"
                             onClick={() => {
                               setWhichSign("manager");
                               setSignCanvas(true);
                             }}
                           />
                         </div>
                       )}
                     </>
                   ) : (
                     <img
                       src={`${Bucket}${formContent?.managerWarehouseSign}`}
                       height={80}
                       alt="Manager Sign"
                     />
                   )}
                 </div>
                 <p className="text-center">{"_______________________________"}</p>
                 <p className="my-1 text-center">
                   <b>{"Manager Warehouse"}</b>
                 </p>
               </Grid>
                <Grid item xs={12} sm={6}>
                 <div
                   style={{ height: "90px" }}
                   className="d-flex justify-content-center align-items-end"
                 >
                   {formContent?.carpenterSign?.trim()?.length == 0 ? (
                    <>
                       {isEdit && (
                         <div className="d-flex justify-content-center align-items-end">
                           <label
                             htmlFor="uploadSign2"
                             className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                           >
                             {uploadText2}
                           </label>
                           <input
                             type="button"
                             hidden
                             id="uploadSign2"
                             name="uploadSign2"
                             onClick={() => {
                               setWhichSign("carpenter");
                               setSignCanvas(true);
                             }}
                           />
                         </div>
                       )}
                     </>
                   ) : (
                     <img
                       src={`${Bucket}${formContent.carpenterSign}`}
                       height={80}
                       alt="Carpenter Sign"
                     />
                   )}
                 </div>
                 <p className="text-center">{"_______________________________"}</p>
                 <p className="my-1 text-center">
                   <b>{"Carpenter"}</b>
                 </p>
               </Grid>
             </Grid>
           </PremiumCard>

            <Snackbar
              open={openSnackbar}
              autoHideDuration={6000} // Adjust the duration as needed
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MuiAlert
                elevation={6}
                variant="filled"
                severity={
                  snackbarMessage?.includes("successful") ? "success" : "error"
                }
                onClose={handleCloseSnackbar}
              >
                {snackbarMessage}
              </MuiAlert>
            </Snackbar>
            </PremiumPublicLayout>

          <PrintComponent>
            <WoodenLiftPageDownload
              surveyData={surveyData}
              formContent={formContent}
            />
          </PrintComponent>
        </>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
    </>
  );
};

export default WoodenLiftPageClientSide;
